import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import { useDotButton } from "./DotButtons";
import { PrevButton, NextButton, usePrevNextButtons } from "./ArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import { Link } from "react-router-dom";

interface ITestimonial {
  id: number;
  name: string;
  description: string;
  position: string;
  linkedin: string;
  secondPosition?: string;
  image?: string;
  seeMore?: string;
}

type PropType = {
  slides: ITestimonial[];
  options?: EmblaOptionsType;
};

const Carousel: React.FC<PropType> = (props) => {
  const { slides, options } = props;
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex } = useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <div className="flex flex-col justify-center items-center w-full">
      <div className="flex items-center h-full justify-center relative bg-white">
        {/* <div className="flex justify-center z-10 absolute top-[10rem] sm:top-[11rem] md:top-[10.5rem] -translate-y-1/2 -left-[3.2rem] lg:top-[12.5rem] xl:top-[14rem] xl:-left-[5.6rem] 2xl:-left-[7rem]">
          <div className="h-32 sm:h-44 md:h-56 lg:h-72 xl:h-[19rem] 2xl:h-[24rem]">
            <img
              src="/careers/testimonials/image-1.png"
              alt=""
              className="h-full"
            />
          </div> bg-[#F7F9FC] 
        </div> */}
        <div className="grid justify-center md:max-w-3xl lg:max-w-[67rem]">
          <div
            className="overflow-hidden shadow-xl p-3 sm:p-5 lg:p-7 relative"
            ref={emblaRef}
          >
            <div className="flex">
              {slides.map((testimonial) => {
                return (
                  <div
                    key={testimonial.id}
                    className="flex gap-5 p-2 md:p-10 min-w-full justify-center items-center"
                  >
                    <div className="flex justify-center">
                      <div className="hidden md:flex sm:h-44 md:h-56 pt-3 lg:h-72 xl:h-[17rem] 2xl:h-[16rem] ">
                        <img
                          src={
                            testimonial?.image ||
                            "/careers/testimonials/image-1.png"
                          }
                          alt=""
                          className="h-full w-full z-10"
                        />
                      </div>
                    </div>
                    <div className="flex md:ml-4 gap-2 max-w-[30rem] xl:max-w-[43rem]">
                      <div className="lg:pt-1 xl:pt-[1.1rem]">
                        <img src="/careers/quote.png" alt="" className="w-5" />
                      </div>
                      <div className="flex-1 flex flex-col justify-center pt-3">
                        <div className="flex flex-col">
                          <p className="text-xs sm:text-sm md:text-base font-light pr-4">
                            {testimonial.description}
                          </p>
                          <div className="py-4 text-xs md:text-sm xl:text-lg">
                            <h4 className="font-bold">{testimonial.name}</h4>
                            <h6 className="font-normal text-xs md:text-base">
                              {testimonial.position}
                            </h6>
                            {testimonial.secondPosition && (
                              <h6 className="font-normal md:text-base">
                                {testimonial.secondPosition}
                              </h6>
                            )}
                            {testimonial?.seeMore && (
                              <div className="flex justify-end pt-2">
                                <Link to={testimonial?.seeMore} target="_blank">
                                  <button className="text-xs md:text-sm px-3 py-1 bg-blue-600 rounded-md text-white">
                                    See More
                                  </button>
                                </Link>
                              </div>
                            )}
                            {/* <a
                              href={testimonial.linkedin}
                              target="_blank"
                              rel="noreferrer"
                              className="flex gap-2 items-center pt-4"
                            >
                              <div>
                                <img
                                  src="/careers/icons/linkedin.svg"
                                  alt=""
                                  className="w-5"
                                />
                              </div>
                              <span className="text-[#646363] text-xs">
                                LinkedIn profile
                              </span>
                            </a> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="flex  justify-between items-center pt-4 shadow-none">
            <div className="flex items-center gap-1 text-xs">
              {selectedIndex + 1}/{slides.length} <div>testimonials</div>
            </div>
            <div className="embla__buttons">
              <PrevButton
                onClick={onPrevButtonClick}
                disabled={prevBtnDisabled}
              />
              <NextButton
                onClick={onNextButtonClick}
                disabled={nextBtnDisabled}
              />
            </div>
            {/* 
            <div className="border">
              {scrollSnaps.map((_, index) => (
                <DotButton
                  key={index}
                  onClick={() => onDotButtonClick(index)}
                  className={"border bg-white w-3 h-3".concat(
                    index === selectedIndex ? "border bg-black w-3 h-3" : "",
                  )}
                />
              ))}
            </div> */}
          </div>
        </div>
        {/* <div className="flex justify-center z-10 absolute top-[10rem] sm:top-[11rem] md:top-[10.5rem] -translate-y-1/2 -right-[1rem] sm:-right-[2rem] lg:top-[12.5rem] xl:top-[14rem] xl:-right-[5rem]">
          <div className="h-32 sm:h-44 md:h-56 lg:h-72 xl:h-[19rem] 2xl:h-[24rem]">
            <img
              src="/careers/testimonials/image-2.png"
              alt=""
              className="h-full"
            />
          </div>
          <div className="h-32 sm:h-44 md:h-56 lg:h-72 xl:h-[19rem] 2xl:h-[24rem]">
            <img
              src="/careers/testimonials/image-3.png"
              alt=""
              className="h-full"
            />
          </div>
          <div className="h-32 sm:h-44 md:h-56 lg:h-72 xl:h-[19rem] 2xl:h-[24rem]">
            <img
              src="/careers/testimonials/image-4.png"
              alt=""
              className="h-full"
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Carousel;
